<template>

	<div :class="{'buttonNextPage-white': isWhite}" class="buttonNextPage">
		<router-link :to="{name: 'page', params: { page: pagePath }}">
			<FaIcon name="chevron-down"/>
			<div class="buttonNextPage_title">{{$t("next")}} <span v-html="title"></span></div>
			<div v-if="subTitle" class="buttonNextPage_subtitle">{{subTitle}}</div>
		</router-link>
		<slot></slot>
	</div>

</template>

<script>

import {Locales} from "../plugin/Locales";
import Arrow from "./Arrow";
import FaIcon from "./FaIcon";

export default {
	name: "ButtonNextPage",
	components: {FaIcon, Arrow},
	data() {
		return {
			pagePath: Locales.getPageInfos(this.page).segment
		};
	},
	props: {
		isWhite: {
			type: Boolean,
			default: false
		},
		page: {
			type: String,
			default: "/"
		},
		title: {
			type: String,
			default: "Title"
		},
		subTitle: {
			type: String,
			default: ""
		}
	}
};
</script>

<style lang="scss" scoped>
.buttonNextPage {
	color: #000000;
	text-align: center;
	padding: $G-default*1.5 0 $G-default 0;
	display: inline-block;
	margin-left: 50%;
	transform: translateX(-50%);
	@include breakpoint(xs) {
		padding-bottom: $G-default*4;
	}

	&-white {
		color: #ffffff;
	}

	&_title {
		font-family: $F-Montserrat;
		font-size: 1.8rem;
		font-weight: $FW-semibold;
		transform: translateY(-20px);
		letter-spacing: 0.05em;
		@include transition();
	}

	a {
		color: currentColor;
		text-decoration: none;
		text-transform: initial;
	}

	.fal {
		transform: translateY(-100%);
		font-size: 3rem;
		@include transition();
	}

	&:hover {
		.fal {
			transform: translateY(-80%);
			@include transition();
		}
	}
}
</style>